import { render } from "./Gallery.vue?vue&type=template&id=55e4207c"
const script = {}

import exportComponent from "C:\\Users\\zelen\\Documents\\dev\\osobni\\finestudio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__